document.querySelectorAll('details').forEach((details) => {
  details.addEventListener('toggle', function () {
    const icon = this.querySelector('.rotate-icon');
    if (!icon) return;
    if (this.open) {
      icon.classList.add('active');
    } else {
      icon.classList.remove('active');
    }
  });
});
//voir plus btn
function triggerVoirTousSubmit() {
  const voirTousInput = document.getElementById('voirTousTrigger');
  if (voirTousInput) {
    voirTousInput.value = 'true';
  }

  const searchForm = document.querySelector('.search-form');
  if (searchForm) {
    searchForm.submit();
  }
}
